export default __webpack_public_path__ + "static/media/vedrajpoot_resume.c1e7a812.pdf";